export default __webpack_public_path__ + "static/media/935.28d22b85.png";